const WafSubstitutionList = [
  { name: 'localhost', sub: 'local' },
  { name: '..', sub: '' }
];

export default WafSubstitutionList;
